import _ from 'lodash'

const combine = (...list) => _.compact(list).join('.')

export { combine }
